<template>
  <div class="slides">
    <div v-for="i in getMaxPage()" :key="i" :id="'slide-' + i">
      <div class="plate9">
        <img :src="base" alt="" />
      </div>
      <div id="seal1" v-if="sealsList.length >= (i - 1) * 9 + 1">
        <img :src="sealsList[(i - 1) * 9].url" alt="" />
        <p class="stroke" :class="{ is_android: isAndroid }">
          {{ sealsList[(i - 1) * 9].ryakusyo }}
        </p>
        <p
          class="t1"
          :class="{ is_android: isAndroid }"
          v-bind:style="{
            color: sealsList[(i - 1) * 9].text_color
          }"
        >
          {{ sealsList[(i - 1) * 9].ryakusyo }}
        </p>
        <p class="t2" :class="{ is_android: isAndroid }">
          {{ getExpiredDate(sealsList[(i - 1) * 9].get_at) }}
        </p>
      </div>
      <div id="seal1" v-else>
        <img src="@/assets/img/seal/no_seal.png" alt="" />
      </div>
      <div id="seal2" v-if="sealsList.length >= (i - 1) * 9 + 2">
        <img :src="sealsList[(i - 1) * 9 + 1].url" alt="" />
        <p class="stroke" :class="{ is_android: isAndroid }">
          {{ sealsList[(i - 1) * 9 + 1].ryakusyo }}
        </p>
        <p
          class="t1"
          :class="{ is_android: isAndroid }"
          v-bind:style="{
            color: sealsList[(i - 1) * 9 + 1].text_color
          }"
        >
          {{ sealsList[(i - 1) * 9 + 1].ryakusyo }}
        </p>
        <p class="t2" :class="{ is_android: isAndroid }">
          {{ getExpiredDate(sealsList[(i - 1) * 9 + 1].get_at) }}
        </p>
      </div>
      <div id="seal2" v-else>
        <img src="@/assets/img/seal/no_seal.png" alt="" />
      </div>
      <div id="seal3" v-if="sealsList.length >= (i - 1) * 9 + 3">
        <img :src="sealsList[(i - 1) * 9 + 2].url" alt="" />
        <p class="stroke" :class="{ is_android: isAndroid }">
          {{ sealsList[(i - 1) * 9 + 2].ryakusyo }}
        </p>
        <p
          class="t1"
          :class="{ is_android: isAndroid }"
          v-bind:style="{
            color: sealsList[(i - 1) * 9 + 2].text_color
          }"
        >
          {{ sealsList[(i - 1) * 9 + 2].ryakusyo }}
        </p>
        <p class="t2" :class="{ is_android: isAndroid }">
          {{ getExpiredDate(sealsList[(i - 1) * 9 + 2].get_at) }}
        </p>
      </div>
      <div id="seal3" v-else>
        <img src="@/assets/img/seal/no_seal.png" alt="" />
      </div>
      <div id="seal4" v-if="sealsList.length >= (i - 1) * 9 + 4">
        <img :src="sealsList[(i - 1) * 9 + 3].url" alt="" />
        <p class="stroke" :class="{ is_android: isAndroid }">
          {{ sealsList[(i - 1) * 9 + 3].ryakusyo }}
        </p>
        <p
          class="t1"
          :class="{ is_android: isAndroid }"
          v-bind:style="{
            color: sealsList[(i - 1) * 9 + 3].text_color
          }"
        >
          {{ sealsList[(i - 1) * 9 + 3].ryakusyo }}
        </p>
        <p class="t2" :class="{ is_android: isAndroid }">
          {{ getExpiredDate(sealsList[(i - 1) * 9 + 3].get_at) }}
        </p>
      </div>
      <div id="seal4" v-else>
        <img src="@/assets/img/seal/no_seal.png" alt="" />
      </div>
      <div id="seal5" v-if="sealsList.length >= (i - 1) * 9 + 5">
        <img :src="sealsList[(i - 1) * 9 + 4].url" alt="" />
        <p class="stroke" :class="{ is_android: isAndroid }">
          {{ sealsList[(i - 1) * 9 + 4].ryakusyo }}
        </p>
        <p
          class="t1"
          :class="{ is_android: isAndroid }"
          v-bind:style="{
            color: sealsList[(i - 1) * 9 + 4].text_color
          }"
        >
          {{ sealsList[(i - 1) * 9 + 4].ryakusyo }}
        </p>
        <p class="t2" :class="{ is_android: isAndroid }">
          {{ getExpiredDate(sealsList[(i - 1) * 9 + 4].get_at) }}
        </p>
      </div>
      <div id="seal5" v-else>
        <img src="@/assets/img/seal/no_seal.png" alt="" />
      </div>
      <div id="seal6" v-if="sealsList.length >= (i - 1) * 9 + 6">
        <img :src="sealsList[(i - 1) * 9 + 5].url" alt="" />
        <p class="stroke" :class="{ is_android: isAndroid }">
          {{ sealsList[(i - 1) * 9 + 5].ryakusyo }}
        </p>
        <p
          class="t1"
          :class="{ is_android: isAndroid }"
          v-bind:style="{
            color: sealsList[(i - 1) * 9 + 5].text_color
          }"
        >
          {{ sealsList[(i - 1) * 9 + 5].ryakusyo }}
        </p>
        <p class="t2" :class="{ is_android: isAndroid }">
          {{ getExpiredDate(sealsList[(i - 1) * 9 + 5].get_at) }}
        </p>
      </div>
      <div id="seal6" v-else>
        <img src="@/assets/img/seal/no_seal.png" alt="" />
      </div>
      <div id="seal7" v-if="sealsList.length >= (i - 1) * 9 + 7">
        <img :src="sealsList[(i - 1) * 9 + 6].url" alt="" />
        <p class="stroke" :class="{ is_android: isAndroid }">
          {{ sealsList[(i - 1) * 9 + 6].ryakusyo }}
        </p>
        <p
          class="t1"
          :class="{ is_android: isAndroid }"
          v-bind:style="{
            color: sealsList[(i - 1) * 9 + 6].text_color
          }"
        >
          {{ sealsList[(i - 1) * 9 + 6].ryakusyo }}
        </p>
        <p class="t2" :class="{ is_android: isAndroid }">
          {{ getExpiredDate(sealsList[(i - 1) * 9 + 6].get_at) }}
        </p>
      </div>
      <div id="seal7" v-else>
        <img src="@/assets/img/seal/no_seal.png" alt="" />
      </div>
      <div id="seal8" v-if="sealsList.length >= (i - 1) * 9 + 8">
        <img :src="sealsList[(i - 1) * 9 + 7].url" alt="" />
        <p class="stroke" :class="{ is_android: isAndroid }">
          {{ sealsList[(i - 1) * 9 + 7].ryakusyo }}
        </p>
        <p
          class="t1"
          :class="{ is_android: isAndroid }"
          v-bind:style="{
            color: sealsList[(i - 1) * 9 + 7].text_color
          }"
        >
          {{ sealsList[(i - 1) * 9 + 7].ryakusyo }}
        </p>
        <p class="t2" :class="{ is_android: isAndroid }">
          {{ getExpiredDate(sealsList[(i - 1) * 9 + 7].get_at) }}
        </p>
      </div>
      <div id="seal8" v-else>
        <img src="@/assets/img/seal/no_seal.png" alt="" />
      </div>
      <div id="seal9" v-if="sealsList.length >= (i - 1) * 9 + 9">
        <img :src="sealsList[(i - 1) * 9 + 8].url" alt="" />
        <p class="stroke" :class="{ is_android: isAndroid }">
          {{ sealsList[(i - 1) * 9 + 8].ryakusyo }}
        </p>
        <p
          class="t1"
          :class="{ is_android: isAndroid }"
          v-bind:style="{
            color: sealsList[(i - 1) * 9 + 8].text_color
          }"
        >
          {{ sealsList[(i - 1) * 9 + 8].ryakusyo }}
        </p>
        <p class="t2" :class="{ is_android: isAndroid }">
          {{ getExpiredDate(sealsList[(i - 1) * 9 + 8].get_at) }}
        </p>
      </div>
      <div id="seal9" v-else-if="i === 1">
        <img src="@/assets/img/seal/no_seal9end.png" alt="" />
      </div>
      <div id="seal9" v-else>
        <img src="@/assets/img/seal/no_seal.png" alt="" />
      </div>
    </div>
    <!---->
  </div>
</template>

<script>
export default {
  name: 'SealPlate9',
  props: ['base', 'seals', 'sealsList'],
  data: function() {
    return {
      isAndroid: false
    }
  },
  mounted: function() {
    const ua = window.navigator.userAgent
    if (ua.indexOf('Android') >= 0) {
      this.isAndroid = true
    }
  },
  async created() {},
  methods: {
    changeList: function(isSelect) {
      this.isSelect = isSelect
      this.$emit('click', isSelect)
    },
    getExpiredDate(str) {
      const array = str.split('T')
      const date = array[0].split('-').join('.')
      return `${date}`
    },
    getMaxPage() {
      return ((this.seals.length / 3) | 0) + 1
    }
  }
}
</script>

<style scoped lang="scss">
.slides {
  display: flex;
  overflow-x: hidden;
  overflow-y: hidden;
  scroll-snap-type: x;
  //scroll-behavior: smooth;
  //-webkit-overflow-scrolling: touch;
}

.scroll-snap-container::-webkit-scrollbar {
  display: none !important;
  height: 0;
  width: 0;
  background-color: transparent;
}
.slides > div {
  scroll-snap-align: start;
  flex-shrink: 0;
  position: relative;
  display: flex;
  transform-origin: center center;
  transform: scale(1);
  transition: transform 3s;
}

.plate9 {
  margin-top: 21vw;
  position: relative;
  width: 94vw;
  height: 240vw;
}

.plate9 img {
  width: 100%;
  height: auto;
  display: block;
}

#seal1 {
  margin-top: 31vw;
  margin-left: 7vw;
  position: absolute;
  width: 35vw;
  height: 35vw;
}

#seal1 img {
  width: 100%;
  height: auto;
  display: block;
}

#seal2 {
  margin-top: 54vw;
  margin-left: 52vw;
  position: absolute;
  width: 35vw;
  height: 35vw;
}

#seal2 img {
  width: 100%;
  height: auto;
  display: block;
}

#seal3 {
  margin-top: 77vw;
  margin-left: 7vw;
  position: absolute;
  width: 35vw;
  height: 35vw;
}

#seal3 img {
  width: 100%;
  height: auto;
  display: block;
}

#seal4 {
  margin-top: 100vw;
  margin-left: 52vw;
  position: absolute;
  width: 35vw;
  height: 35vw;
}

#seal4 img {
  width: 100%;
  height: auto;
  display: block;
}

#seal5 {
  margin-top: 123vw;
  margin-left: 7vw;
  position: absolute;
  width: 35vw;
  height: 35vw;
}

#seal5 img {
  width: 100%;
  height: auto;
  display: block;
}

#seal6 {
  margin-top: 147vw;
  margin-left: 52vw;
  position: absolute;
  width: 35vw;
  height: 35vw;
}

#seal6 img {
  width: 100%;
  height: auto;
  display: block;
}

#seal7 {
  margin-top: 170vw;
  margin-left: 7vw;
  position: absolute;
  width: 35vw;
  height: 35vw;
}

#seal7 img {
  width: 100%;
  height: auto;
  display: block;
}

#seal8 {
  margin-top: 193vw;
  margin-left: 52vw;
  position: absolute;
  width: 35vw;
  height: 35vw;
}

#seal8 img {
  width: 100%;
  height: auto;
  display: block;
}

#seal9 {
  margin-top: 215vw;
  margin-left: 7vw;
  position: absolute;
  width: 35vw;
  height: 35vw;
}

#seal9 img {
  width: 100%;
  height: auto;
  display: block;
}

.t1 {
  position: absolute;
  font-size: 3.3vw;
  font-weight: bold;
  text-align: center;
  width: 100%;
  top: 1vw;
  margin: 0;
}

.t1.is_android {
  top: 1.5vw;
}

.stroke {
  position: absolute;
  color: red;
  font-size: 3.3vw;
  font-weight: bold;
  text-align: center;
  width: 100%;
  top: 1vw;
  margin: 0;
  -webkit-text-stroke: 3px white;
  text-stroke: 3px white;
}

.stroke.is_android {
  top: 1.5vw;
}

.t2 {
  position: absolute;
  color: white;
  font-size: 2.3vw;
  text-align: center;
  width: 100%;
  top: 31.5vw;
}

.t2.is_android {
  top: 32vw;
}
</style>
